module.exports = __webpack_public_path__ + "packs/media/images/climber_woman_70x70-b934482596811111a09171f51b871410.jpg";